export function contarTotalesPorRangoDesdeTexto(texto) {
  const codigos = texto
    .split("\n")
    .map((c) => c.trim())
    .filter((c) => /^\d{22}$/.test(c)); // Filtra códigos válidos

  return contarTotalesPorRango(codigos);
}
export function contarTotalesPorRango(codigos) {
  let almuerzo = 0;
  let merienda = 0;
  let fueraRango = 0;

  // Rango en segundos
  const ALMUERZO_MIN = 10 * 3600; // 10:00:00
  const ALMUERZO_MAX = 16 * 3600 + 41 * 60 + 59; // 16:40:59
  const MERIENDA_MIN = 16 * 3600 + 50 * 60 + 59; // 17:00:00
  const MERIENDA_MAX = 23 * 3600 + 59 * 60 + 59; // 23:59:59

  for (const codigo of codigos) {
    const horaStr = codigo.slice(12, 18); // Posiciones 13 a 18 (HHMMSS)

    if (!/^\d{6}$/.test(horaStr)) {
      fueraRango++;
      continue;
    }

    const h = parseInt(horaStr.slice(0, 2), 10);
    const m = parseInt(horaStr.slice(2, 4), 10);
    const s = parseInt(horaStr.slice(4, 6), 10);

    const totalSegundos = h * 3600 + m * 60 + s;

    if (totalSegundos >= ALMUERZO_MIN && totalSegundos <= ALMUERZO_MAX) {
      almuerzo++;
    } else if (totalSegundos >= MERIENDA_MIN && totalSegundos <= MERIENDA_MAX) {
      merienda++;
    } else {
      fueraRango++;
    }
  }

  return`Resultados Totales:\n` +
  `==================================\n`+
  `✅ Almuerzos: ${almuerzo}\n` +
  `🌙 Meriendas: ${merienda}\n` +
  `❌ Fuera de rango: ${fueraRango}\n` +
  `📊 Total procesado: ${ almuerzo + merienda + fueraRango}`/*  {
    almuerzo,
    merienda,
    fueraRango,
    total: almuerzo + merienda + fueraRango,
  }; */
}
